import React, { useContext } from "react";
import { Content } from "../components/Content";
import { contextApi } from "../context/contextApi";
import { Loading } from "../components/common/Loading";
import { useWalletAssets } from "../hooks/useWalletAssets";

export const Cryptocurrency = () => {
  const context = useContext(contextApi);
  const { boxes } = useWalletAssets(2);

  return (
    <div className="px-4 sm:px-6 md:px-10">
      <Loading show={context.load} />
      <Content boxes={boxes} id={2} pageName="رمز ارز" />
    </div>
  );
};
